import React from "react"
import autobind from "class-autobind"
import { IDate, IScheduleDocument, IJobDocument, EScheduleListType, IClientDocument, IScheduleActionResult, IScheduleConstraint } from "../../../models"
import * as api from "../../../api"
import ScheduleInfoDetail from "./ScheduleInfoDetail"
import ScheduleTimeInfoDetail from "./ScheduleTimeInfoDetail"
import strings from "../../../localization/strings"
import _ from "lodash"
import AutoAssignEmployeeConfirmDialog from "./AutoAssignEmployeeConfirmDialog"
import CopyScheduleDialog from "../../../components/schedule/copy_schedule/CopyScheduleDialog"
import AppStateStore from "../../../stores/AppStateStore"
import TimecardPopup from "../../timecard/timecard_popup/TimecardPopup"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import ScheduleConstraintsAlertDialog from "../constraints/ScheduleConstraintsAlertDialog"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
interface IProps {
  type: EScheduleListType
  readonly: boolean
  schedule: IScheduleDocument
  reload(): void
  handleChangeWithoutApiCall(schedule: IScheduleDocument): void
  handlePostMasterScheduleForCurrentWeek(): void

  job: IJobDocument
  client: IClientDocument
}
interface IState {
  openAutoAssignConfirmDialog: boolean
  openTimecardPopup?: boolean
  employeeIdForTimecardPopup?: string
  referenceDateForTimecardPopup?: IDate
  openCopyScheduleDialog: boolean
  selectedClient: IClientDocument
  selectedJob: IJobDocument
  constraintsAlertDialogContent: IScheduleConstraint[]
}

export default class ScheduleDetail extends React.Component<IProps, IState> {
  private reloadAferCloseTimecardPopup
  constructor(props: IProps) {
    super(props)
    if (!props.schedule.Budget) {
      props.schedule.Budget = {}
    }
    props.schedule.Budget.Days = scheduleHelper.initScheduleBudgetDays(props.schedule)
    this.state = {
      openAutoAssignConfirmDialog: false,
      openCopyScheduleDialog: false,
      selectedClient: null,
      selectedJob: null,
      constraintsAlertDialogContent: []
    }
    autobind(this)
  }

  componentDidMount() {
    this.props.schedule.ClientId &&
      api.getClient(this.props.schedule.ClientId).then(res =>
        this.setState({
          selectedClient: res.data
        })
      )
    this.props.schedule.JobId &&
      api.getJob(this.props.schedule.JobId).then(res =>
        this.setState({
          selectedJob: res.data
        })
      )
  }

  handleChange(schedule: IScheduleDocument, successMsg: string, checkValidationShiftIds: string[]): Promise<boolean> {
    const alertContent = this.props.type === EScheduleListType.JobSchedule && this.props.schedule.JobId !== schedule.JobId ?
      strings.You_have_changed_the_job_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_go_to_changed_job :
      this.props.type === EScheduleListType.ClientSchedule && this.props.schedule.ClientId !== schedule.ClientId ?
        strings.You_have_changed_the_client_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_go_to_changed_client :
        !hierarchyHelper.checkHierarchyIsUnderFilterAccessHierarchy(HierarchySettingsStore.getGlobalLevelItemFilterId(), schedule.HierarchyId) ?
          strings.formatString(strings.You_have_changed_the_hierarchy_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_change_your_hierarchy_filter_to_x, hierarchyHelper.getFullyQualifiedLevelNameById(schedule.HierarchyId)) :
          null

    return alertContent ?
      new Promise(resolve => {
        AppStateStore.setAlertDialogContent({
          content: alertContent,
          handleCloseCallBack: () => {
            resolve(this.handleCallUpdateApi(schedule, successMsg, true, checkValidationShiftIds))
          }
        })
      }) :
      this.handleCallUpdateApi(schedule, successMsg, false, checkValidationShiftIds)
  }

  handleCallUpdateApi(schedule: IScheduleDocument, successMsg: string, needReloadPage: boolean, checkValidationShiftIds: string[]): Promise<boolean> {
    return new Promise(resolve => {
      AppStateStore.setProgressSnackbarContent("loading")
      api.checkValidationAndUpdateSchedule(schedule, checkValidationShiftIds)
        .then(res => {
          const result: IScheduleActionResult = res.data
          if (result.Constraints.length === 0) {
            AppStateStore.setProgressSnackbarContent(successMsg)
            needReloadPage ?
              this.props.reload() :
              this.props.handleChangeWithoutApiCall(result.Schedule)
            resolve(true)
          }
          else {
            AppStateStore.setProgressSnackbarContent(null)
            this.setState({ constraintsAlertDialogContent: result.Constraints })
            resolve(false)
          }
        })
        .catch(err => {
          AppStateStore.setProgressSnackbarContent(err.response.data.message)
          resolve(false)
        })
    })
  }

  render() {
    return (
      <div className="page-container">
        {this.props.schedule &&
          <div className="user-details" style={{ marginTop: 0 }}>
            <ScheduleInfoDetail
              type={this.props.type}
              readonly={this.props.readonly}
              schedule={this.props.schedule}
              handleCopySchedule={() => this.props.schedule.HiddenSchedules && this.props.schedule.HiddenSchedules.length > 0 ?
                AppStateStore.setAlertDialogContent({
                  content: strings.Cannot_copy_in_here_Schedule_has_the_shift_which_is_not_shown_here
                }) :
                this.setState({ openCopyScheduleDialog: true })
              }
              handleAutoAssign={() => this.props.schedule.HiddenSchedules && this.props.schedule.HiddenSchedules.length > 0 ?
                AppStateStore.setAlertDialogContent({
                  content: strings.Cannot_auto_assign_in_here_Schedule_has_the_shift_which_is_not_shown_here
                }) :
                this.setState({ openAutoAssignConfirmDialog: true })
              }
              handleUpdateSchedule={schedule => this.handleChange(schedule, null, null)}
              handlePostMasterScheduleForCurrentWeek={this.props.handlePostMasterScheduleForCurrentWeek}
              selectedJob={this.state.selectedJob}
              selectedClient={this.state.selectedClient}
            />
            <ScheduleTimeInfoDetail
              readonly={this.props.readonly}
              type={this.props.type}
              schedule={this.props.schedule}
              handleChange={this.handleChange}
              handleChangeWithoutApiCall={this.props.handleChangeWithoutApiCall}
              callUpdateApi={() => this.handleChange(this.props.schedule, null, null)}
              handleShowTimecardPopup={(employeeIdForTimecardPopup, referenceDateForTimecardPopup) =>
                this.setState({
                  openTimecardPopup: true,
                  employeeIdForTimecardPopup,
                  referenceDateForTimecardPopup
                })
              }
              scheduleJob={this.state.selectedJob || this.props.job}
              scheduleClient={this.state.selectedClient || this.props.client}
            />
          </div>
        }
        {this.state.openTimecardPopup &&
          <TimecardPopup
            readonly
            open={this.state.openTimecardPopup}
            employeeId={this.state.employeeIdForTimecardPopup}
            referenceDate={this.state.referenceDateForTimecardPopup}
            handleClose={() => {
              this.setState({ openTimecardPopup: false, employeeIdForTimecardPopup: null, referenceDateForTimecardPopup: null })
              if (this.reloadAferCloseTimecardPopup) {
                this.props.reload()
                this.reloadAferCloseTimecardPopup = false
              }
            }}
            handleRecalcPage={() => this.reloadAferCloseTimecardPopup = true}
          />
        }
        {this.state.openCopyScheduleDialog &&
          <CopyScheduleDialog
            schedules={[this.props.schedule]}
            handleClose={() => this.setState({ openCopyScheduleDialog: false })}
            job={this.props.job}
            client={this.props.client}
          />
        }
        {this.state.openAutoAssignConfirmDialog &&
          <AutoAssignEmployeeConfirmDialog
            schedule={this.props.schedule}
            close={() => this.setState({ openAutoAssignConfirmDialog: false })}
            handleAutoAssign={limitToShiftHierarchy => {
              AppStateStore.setProgressSnackbarContent("loading")
              this.setState({ openAutoAssignConfirmDialog: false })
              api.autoAssignSchedulePlanner(this.props.schedule.Id, false, limitToShiftHierarchy).then(res => {
                AppStateStore.setProgressSnackbarContent(strings.Schedule_auto_assign_has_completed)
                this.props.reload()
              })
            }}
          />
        }
        {this.state.constraintsAlertDialogContent.length > 0 &&
          <ScheduleConstraintsAlertDialog
            constraints={this.state.constraintsAlertDialogContent}
            handleClose={() => this.setState({ constraintsAlertDialogContent: [] })}
          />
        }
      </div>
    )
  }
}